module.exports = __webpack_public_path__ + "img/product_img.fc505bab.png";